import React from 'react'

import ValuePagesTemplate from '../components/ValuePagesTemplate'
import Text from '../components/Text'
import PageTitle from '../components/PageTitle'

const ConversationsPage = () => (
  <ValuePagesTemplate>
      <PageTitle title='Candid Conversations' />
      <Text>We have real, honest conversations. We'd rather come across as aggressive and obnoxious than manipulative and insincere.</Text>
      <Text>We challenge directly because we care personally.</Text>
  </ValuePagesTemplate>
)

export default ConversationsPage



// WEBPACK FOOTER //
// ./src/pages/candid-conversations.js